import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { DiscountBlock } from '../DiscountBlock';
import { SubscriptionCardV7 } from '../SubscriptionCardV7';
import { PaymentInformationBlock } from '../PaymentInformationBlock';
import { CancelAnytimeBlock } from '../CancelAnytimeBlock';
import styles from './SubscriptionPlanSelectorV7.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV7({ className = '', plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, expiryTimestamp, onExpirePromo, isExpired, hasPaymentInformation = true }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const radioGroupName = useId();

    return (
        <div className={classes}>
            <DiscountBlock
                expiryTimestamp={expiryTimestamp}
                onExpirePromo={onExpirePromo}
                isExpired={isExpired}
            />
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCardV7
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        isExpired={isExpired}
                        name={radioGroupName}
                        key={plan.plan}
                    />
                ))}
            </div>
            <Button
                type='accent'
                label='Get my plan'
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={cx('button', 'animation')}
                isLoading={isPending}
            />
            <CancelAnytimeBlock />
            {hasPaymentInformation && <PaymentInformationBlock label='pay securely' />}
        </div>
    );
}

SubscriptionPlanSelectorV7.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    expiryTimestamp: PropTypes.any,
    onExpirePromo: PropTypes.func,
    isExpired: PropTypes.bool,
    hasPaymentInformation: PropTypes.bool
};

export {
    SubscriptionPlanSelectorV7
};
